<template>

  <div class="app-container">

    <el-card class="mb20 mt20 ml20 mr20 ta-l" v-show="showSearch" ref="searchBox">
      <el-form :model="queryParams" ref="queryForm" size="small" :inline="true">
        <el-form-item label="订单编号" prop="tradeNo">
          <el-input
              v-model="queryParams.tradeNo"
              placeholder="请输入订单编号"
              clearable
              style="width: 240px"
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="信用代码" prop="businessCode">
          <el-input
              v-model="queryParams.businessCode"
              placeholder="请输入刻企信用代码"
              clearable
              style="width: 240px"
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="刻企名称" prop="makeBusinessName" v-if="orgCode === '91210204341167191F'">
          <el-input
              v-model="queryParams.makeBusinessName"
              placeholder="请输入刻企名称"
              clearable
              style="width: 240px"
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="企业名称" prop="businessName">
          <el-input
              v-model="queryParams.businessName"
              placeholder="请输入企业名称"
              clearable
              style="width: 240px"
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="订单来源" prop="sealName" v-if="orgCode === '91210204341167191F'">
          <el-select v-model="queryParams.isKq" style="width: 240px" clearable placeholder="请选择">
            <el-option
                v-for="item in isKqData"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付状态" prop="payStatus" v-if="orgCode === '91210204341167191F'">
          <el-select v-model="queryParams.payStatus" style="width: 240px" clearable placeholder="请选择">
            <el-option
                v-for="item in payStatusOption"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!--        <el-form-item label="" prop="" v-if="orgCode === '91210204341167191F'">-->
        <!--          <el-checkbox v-model="queryParams.isKq" :true-label="true" :false-label="null">刻企</el-checkbox>-->
        <!--        </el-form-item>-->
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="mb20 mt20 ml20 mr20 ta-l">
      <div>
        <div class="button-box flex-center-end" ref="buttonBox">
          <right-toolbar :showSearch.sync="showSearch" @queryTable="handleQuery"
                         storageKey="xxxxxxxx" @getColumns="getColumns"></right-toolbar>
        </div>
        <el-table
            v-loading="loading"
            :data="tableData"
            :height="getDynamicStyles(showSearch)"
            @expand-change="load"
            style="width: 100%">
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div style="margin: 10px 50px">
                <el-table :data="scope.row.children">
                  <el-table-column
                      prop="goodsName"
                      align="center"
                      label="印章名称">
                  </el-table-column>
                  <el-table-column
                      prop="sealType"
                      label="印章材质"
                      align="center">
                    <template slot-scope="scope">
                      <el-tag size="small" v-if="scope.row.sealMaterial == '01'">水晶章</el-tag>
                      <el-tag size="small" v-if="scope.row.sealMaterial == '02'">回墨章</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                      prop="sealPrice"
                      align="center"
                      label="价格">
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="tradeNo"
              label="订单编号"
              width="180">
          </el-table-column>
          <el-table-column
              prop="orgName"
              label="企业名称">
          </el-table-column>
          <el-table-column
              v-if="orgCode === '91210204341167191F'"
              prop="makeOrgName"
              label="刻企名称">
          </el-table-column>
          <el-table-column
              prop="status"
              label="状态"
              align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status == 1" size="small">已付款</el-tag>
              <el-tag v-if="scope.row.status == 0" size="small" type="warning">未付款</el-tag>
              <el-tag v-if="scope.row.status == -1" size="small" type="danger">备案失败</el-tag>
            </template>
          </el-table-column>
          <el-table-column
              prop="createTime"
              label="订单创建时间"
              align="center">
          </el-table-column>
          <el-table-column
              align="center"
              label="操作"
              width="120">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="handleCheck(scope.row)">查看</el-button>

              <!--              <el-popconfirm-->
              <!--                  class="ml10"-->
              <!--                  @confirm="handleRefund(scope.row)"-->
              <!--                  v-if="scope.row.payStatus == 1 && orgCode === '91210204341167191F'"-->
              <!--                  :title="'是否确认退款 ：' + scope.row.productName + '?'"-->
              <!--              >-->
              <!--                <el-button size="mini" type="text" slot="reference">退款</el-button>-->
              <!--              </el-popconfirm>-->
            </template>
          </el-table-column>
        </el-table>


        <div class="pagination-container" ref="pagination">
          <pagination
              :total="total"
              :page.sync="queryParams.pageNum"
              :limit.sync="queryParams.pageSize"
              @pagination="getTradeInfoList"

          />
        </div>

        <shipping-details ref="details" @handleQuery="getTradeInfoList"/>

      </div>
    </el-card>

  </div>

</template>

<script>
import {enumDevice} from '@/utils/Ukey'
import ShippingDetails from "@/pages/customerEnterprise/components/shippingDetails.vue";
import {getDynamicStyles} from "@/utils/ruoyi";

export default {
  name: "orderList",
  components: {ShippingDetails},
  data() {
    return {
      tableKey: 0,
      showSearch: true,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      // 遮罩层
      loading: true,
      // 总条数
      total: 0,

      tableData: [],

      sealData: [],

      statusOption: [
        {
          value: '0',
          label: '待制作'
        },
        {
          value: '1',
          label: '正常'
        },
        {
          value: '9',
          label: '注销'
        },
      ],

      payStatusOption: [
        {
          value: '0',
          label: '未付款'
        },
        {
          value: '1',
          label: '已付款'
        },
        {
          value: '9',
          label: '已退款'
        },
      ],

      makeTypeOption: [
        {
          value: 'ukey',
          label: 'k章'
        },
        {
          value: 'cloud',
          label: '云章'
        },
      ],

      isKqData: [
        {
          value: 'true',
          label: '客企'
        },
        {
          value: 'false',
          label: '印章平台'
        },
      ],

      userInfo: {},
      orgCode: ''
    }
  },
  created() {
    this.handleQuery()
  },
  methods: {
    getDynamicStyles,
    getColumns(e) {
      this.tableKey += 1
      this.$set(this, 'columns', e)
    },
    handleRefund(e) {
      this.loading = true
      this.$http.post(this.$api.customerEnterprise.refund, {tradeNo: e.tradeNo}).then((res) => {
        if (res.data.code == 200) {
          this.$message.success("退款成功");
          this.getTradeInfoList()
        } else {
          this.$message.error(res.data.msg)
          this.loading = false
        }
      })
    },
    load(value) {
      this.$http.post(this.$api.customerEnterprise.getPhysicalSealOrderDetail, {tradeNo: value.tradeNo}).then((res) => {
        if (res.data.code == 200) {
          this.$set(this.tableData[value.index], 'children', res.data.data)
        }
      })
    },
    handleCheck(e) {
      this.$refs.details.show(true, e.tradeNo, e.deliverNo);
    },
    getTradeInfoList() {
      this.loading = true
      this.$http.get(this.$api.customerEnterprise.getPhysicalSealOrderList, this.queryParams).then((res) => {
        if (res.data.code == 200) {
          let tableData = res.data.rows
          tableData.forEach((e, index) => {
            e.children = []
            e.index = index
          })
          this.tableData = tableData
          this.total = res.data.total
          this.loading = false;
        } else {
          this.$message.error(res.data.msg)
          this.loading = false
        }
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getTradeInfoList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        isKq: null
      },
          this.handleQuery();
    },
  }
}
</script>

<style scoped lang="less">

</style>
